
export function isPhone(value) {
  if (!/^1(3|4|5|7|8)\d{9}$/.test(value)) {
    return false
  } else {
    return true
  }
}

//验证码六位数校验
export function isSixNum(value) {
  if (!/^\d{6}$/.test(value)) {
    return false
  } else {
    return true
  }
}

//身份证号不严格校验
export function isCard(value) {
  if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value)) {
    return false
  } else {
    return true
  }
}

//身份证号严格校验
export function identityIDCard(code) {
  //身份证号前两位代表区域
  var city = {
    11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古",
    21: "辽宁", 22: "吉林", 23: "黑龙江 ",
    31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东",
    41: "河南", 42: "湖北 ", 43: "湖南", 44: "广东", 45: "广西", 46: "海南",
    50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏 ",
    61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆",
    71: "台湾",
    81: "香港", 82: "澳门",
    91: "国外 "
  };
  //身份证格式正则表达式
  var idCardReg = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i;
  var errorMess = "";//错误提示信息
  var isPass = true;//身份证验证是否通过（true通过、false未通过）

  //如果身份证不满足格式正则表达式
  if (!code || !idCardReg.test(code)) {
    errorMess = "您输入的身份证号格式有误！";
    isPass = false;
  }

  //区域数组中不包含需验证的身份证前两位
  else if (!city[code.substr(0, 2)]) {
    errorMess = "您输入的身份证地址编码有误！";
    isPass = false;
  }
  else {
    //18位身份证需要验证最后一位校验位
    if (code.length == 18) {
      code = code.split('');
      //∑(ai×Wi)(mod 11)
      //加权因子
      var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      //校验位
      var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
      var sum = 0;
      var ai = 0;
      var wi = 0;
      for (var i = 0; i < 17; i++) {
        ai = code[i];
        wi = factor[i];
        sum += ai * wi;
      }
      var last = parity[sum % 11];
      if (parity[sum % 11] != code[17]) {
        errorMess = "您输入的身份证号不存在！";
        isPass = false;
      }
    }
  }
  var returnParam = {
    'errorMess': errorMess,
    'isPass': isPass
  }
  return returnParam;
}

/** 
 * 时间戳格式化函数 
 */
export function timestampToTime(timestamp,type="datetime") {
	console.log(timestamp,type)
  //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  if(timestamp.length == 10){
    var date = new Date(timestamp * 1000)
  }else{
    var date = new Date(timestamp)
  }
  var Y = date.getFullYear();
  var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1);
  var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate());
  var h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours());
  var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes());
  var s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds());
  if(type == 'datetime'){
    var strDate = Y+'-'+M+'-'+D+' '+h+ ':' + m + ':'+ s;
  }else if(type == 'year'){
    var strDate = Y
  }else if(type == 'month'){
    var strDate = M
  }else if(type == 'day'){
    var strDate = D
  }else if(type == 'date'){
    var strDate = Y+'-'+M+'-'+D
  }else if(type == 'time'){
    var strDate = h+m+s
  }else if(type == 'MDhm'){
    var strDate = M+'-'+D+' '+ h + ':' + m
  }
  return strDate;
}

/** 
 *  倒计时 返回时间
 */
export function countDown(e){
  //2016-12-27 12:47:08 转换日期格式
  var a = e.split(/[^0-9]/);
  //截止日期：日期转毫秒
  var expireMs = new Date(a[0], a[1] - 1, a[2], a[3], a[4], a[5]);

  //倒计时毫秒
  var duringMs = (expireMs.getTime() + 86400000) - (new Date()).getTime();
  // 渲染倒计时时钟

  var second = Math.floor(duringMs / 1000);
  // 小时位
  var hr = Math.floor(second / 3600);
  let num = Math.floor((second - hr * 3600) / 60)
  let nums = second % 60
  // 分钟位
  var min = num < 10 ? "0" + num : num;
  // 秒位
  var sec = nums < 10 ? "0" + nums : nums;
  return [hr + ":" + min + ":" + sec + " ",duringMs]    //返回过滤后的时间，和毫秒
}

 /*
  * 高亮封装
  * key 是关键字
  * word 是要检索的字符串
  * new_arry 接收截取的字符串
  */
 export function light(key, word, new_arry = []){
  var index = word.indexOf(key);
  if (index > -1){
    var part_before = word.slice(0, index);//截取 关键字前面部分 字符串
    var part_after = word.slice(index + key.length, );//截取 关键字后面部分 字符串
    new_arry.push({ key: false, word: part_before });
    new_arry.push({ key: true, word: key });
    if (part_after.indexOf(key) > -1) {//如果关键字后面部分 字符串 还存在 关键字key，利用递归在继续查询
      this.light(key, part_after, new_arry);
    } else {//否则 将关键字后面部分 字符串压入数组
      new_arry.push({ key: false, word: part_after });
    }
  }
  return new_arry;
}



/**
 * canvas  绘制一行字
 * ctx  canvasid
 * str 文字内容
 * x  横轴
 * y 纵轴
 * font  字体大小
 * style  字体颜色
 * align 文字对齐方式
 * baseLine 文字的竖直对齐方式
 */
export function drawNormalText(ctx, str, x, y, font, style = "#333333", align = 'center', baseLine = 'middle') {
  ctx.setFontSize(font);   //文字大小
  ctx.setFillStyle(style);  //文字颜色
  ctx.setTextAlign(align);   //文字对齐方式
  ctx.setTextBaseline(baseLine);  //文字的竖直对齐方式
  ctx.fillText(str, x, y); //文字 定位
}

 



// WEBPACK FOOTER //
// ./src/util/util.js